import { Card, Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { ChevronRight } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { SimpleCrud } from "src/components/SimpleCrud";
import { Subcontrato } from "src/models/Empresa";
import {
	agregarSubcontratoEmpresa,
	agregarErrorTipoSubcontrato,
	quitarSubcontratoEmpresa,
	eliminarErrorTipoSubcontrato,
	actualizarSubcontratoEmpresa,
	actualizarErrorTipoSubcontrato,
} from "src/redux/actions/businessActions";
import { IBusinessState } from "src/redux/reducers/businessReducer";
import { RootState } from "src/redux/store/reducer";

export const BusinessSubcontractTab = () => {
	const dispatch = useDispatch();
	const {
		edit: { selectedBusiness },
		typeErrors: { isLoading: typeErrorsLoading },
		subContracts: { isLoading: subContractsIsLoading },
	} = useSelector<RootState, IBusinessState>(
		(state) => state.businessReducer
	);

	const [selectedSubContract, setSelectedSubContract] =
		useState<Subcontrato | undefined>();

	// Transform the arrays to match CrudValue type
	const subcontratosArray = selectedBusiness?.Subcontratos 
		? [...new Set(selectedBusiness.Subcontratos)].map((subcontrato, index) => ({
			...subcontrato,
			Nombre: subcontrato.Nombre || '',
			Activado: true,
			index
		}))
		: [];

	// Transform the ErroresTipo array to match CrudValue type
	const erroresTipoArray = selectedSubContract?.ErroresTipo 
		? [...new Set(selectedSubContract.ErroresTipo)].map((error, index) => ({
			Nombre: typeof error === 'string' ? error : error.Nombre || '',
			Activado: true,
			index
		}))
		: [];

	return (
		<Grid container spacing={4}>
			<Grid item xs={6}>
				<SimpleCrud
					key={"SubContratos"}
					array={subcontratosArray}
					isLoading={subContractsIsLoading}
					name="Subcontrato"
					onCreateOrUpdate={(
						values,
						action,
						selected
					) => {
						// Convert CrudValue to Subcontrato
						const subcontratoValues = values as unknown as Subcontrato;
						const subcontratoSelected = selected as unknown as Subcontrato;

						if (action === "New") {
							dispatch(agregarSubcontratoEmpresa(subcontratoValues));
						} else if (action === "Edit") {
							dispatch(
								actualizarSubcontratoEmpresa(
									subcontratoSelected.Nombre,
									{
										...subcontratoSelected,
										...subcontratoValues,
									}
								)
							);
						}
					}}
					onDelete={(selected) => {
						// Convert CrudValue to Subcontrato
						const subcontratoSelected = selected as unknown as Subcontrato;
						dispatch(
							quitarSubcontratoEmpresa(subcontratoSelected.Nombre)
						);
					}}
					cardTitle={"Subcontratos"}
					extraActions={[
						{
							tooltipText: "Errores Tipo",
							icon: <ChevronRight />,
							handleAction: setSelectedSubContract,
						},
					]}
				/>
			</Grid>
			{/* Errores tipo */}
			<Grid item xs={6}>
				{selectedSubContract ? (
					<SimpleCrud
						key={"ErroresTipo"}
						array={erroresTipoArray}
						isLoading={typeErrorsLoading}
						name="ErroresTipo"
						onCreateOrUpdate={(
							values,
							action,
							selected
						) => {
							if (action === "New") {
								dispatch(
									agregarErrorTipoSubcontrato(
										selectedSubContract.Nombre,
										values,
										setSelectedSubContract
									)
								);
							} else if (action === "Edit") {
								dispatch(
									actualizarErrorTipoSubcontrato(
										selectedSubContract.Nombre,
										selected.Nombre,
										values,
										setSelectedSubContract
									)
								);
							}
						}}
						onDelete={(selected) => {
							dispatch(
								eliminarErrorTipoSubcontrato(
									selectedSubContract.Nombre,
									selected.Nombre,
									setSelectedSubContract
								)
							);
						}}
						cardTitle={
							"Errores Tipo - " +
							selectedSubContract?.Nombre
						}
					/>
				) : (
					<Card style={{ minHeight: 250 }}>
						<Grid
							container
							direction="column"
							alignItems="center"
							justify="center"
						>
							<Grid item>
								<img
									style={{
										marginTop: 20,
										marginBottom: 20,
									}}
									alt="Imagen vacía"
									src="/static/void.svg"
									height="150"
								/>
							</Grid>
							<Grid item>
								<Typography variant="h5">
									Ningún sub-contrato seleccionado
								</Typography>
							</Grid>
						</Grid>
					</Card>
				)}
			</Grid>
		</Grid>
	);
};
